/* Shared constants + helpers for the Feature Updates pages. */

export const MAX_FILES = 10;
export const MAX_FILE_BYTES = 50 * 1024 * 1024; // 50 MB
export const IMAGE_TYPES = ["image/png", "image/jpeg", "image/gif", "image/webp"];
export const VIDEO_TYPES = ["video/mp4", "video/webm", "video/quicktime"];
export const MEDIA_ACCEPT =
  "image/png,image/jpeg,image/gif,image/webp,video/mp4,video/webm,video/quicktime";

export const BASE_PATH = "/admin/product-access/features";

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
};

export const fileKind = (file) => {
  const mime = file.type || "";
  if (IMAGE_TYPES.includes(mime) || mime.startsWith("image/")) return "image";
  if (VIDEO_TYPES.includes(mime) || mime.startsWith("video/")) return "video";
  return null;
};
